export default __webpack_public_path__ + "static/media/Cootie (2686).ac3b60df.jpg";